import { takeEvery, put, select, call, all } from 'redux-saga/effects'
import { updateModalStore } from '../../../store/Modal/types/AdsEdit/actions'
import { OPEN_MODAL, openModal } from '../../../store/Modal/actions'
import axios from 'axios'
import { showAlertError } from '../../../store/Alert/actions'


export default function* () {
    yield takeEvery(OPEN_MODAL, worker)
}

function* worker({ payload }) {

    if (payload.type === "adsEditPrepare") {
        try {
            const selectedTrack = yield select(state => state.tracks.selected[0])


            const adsData = yield call(fetchClip, selectedTrack);


            if (adsData?.error) {
                yield put(showAlertError({
                    errors: [`Ошибка сети при ${OPEN_MODAL}.`, adsData.error],
                    text: "Ролик не был загружен. Попробуйте повторить."
                }))
            }
            
            yield put(openModal({ type: "adsEdit", data: { adsData: { ...adsData.success[0] } } }))
        } catch (e) {
            yield put(showAlertError({
                errors: [`Ошибка сети при ${OPEN_MODAL}.`, e],
                text: "Ролик не был сохранён. Попробуйте повторить."
            }))
        }

    }

    if (payload.type === "adsEditExtraPrepare") {


        try {
            const selectedTrack = yield select(state => state.tracks.selected[0])

            let adsData = yield call(fetchExtraClip, selectedTrack)

            if (adsData.error) {
                yield put(showAlertError({
                    errors: [`Ошибка сети при ${OPEN_MODAL}.`, adsData],
                    text: "Ролик не был сохранён. Попробуйте повторить."
                }))
            }

            yield put(openModal({ type: "adsEditExtra", data: { adsData: adsData.success[0] } }))
        } catch (e) {
            yield put(showAlertError({
                errors: [`Ошибка сети при ${OPEN_MODAL}.`, e],
                text: "Ролик не был сохранён. Попробуйте повторить."
            }))
        }

    }
}


function fetchClip(id) {
    return axios.get("/clip/select", { params: { id } })
        .then(response => response.data)
}

function fetchClipHistory(id) {
    return axios.get("/clip/relative", { params: { id } })
        .then(response => response.data)
}


function fetchExtraClip(id) {
    return axios.get("/clip/extra/select", { params: { id } })
        .then(response => response.data)
}